import locale77427e78 from '../../lang/en.js'

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en","numberFormats":{"en":{"currency":{"style":"currency","currency":"AUD","currencyDisplay":"narrowSymbol"}}},"dateTimeFormats":{"en":{"short":{"year":"numeric","month":"short","day":"numeric"},"long":{"year":"numeric","month":"short","day":"numeric","weekday":"short","hour":"numeric","minute":"numeric"}},"en-AU":{"date":{"day":"2-digit","month":"2-digit","year":"numeric"}}}},
  vueI18nLoader: false,
  locales: [{"code":"en","label":"English","file":"en.js","iso":"en","dir":"ltr"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "/webapp/websites/amx/lang/",
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"vsf-locale","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  currency: "AUD",
  country: "AU",
  countries: [{"name":"AU","label":"Australia"}],
  currencies: [{"name":"AU","label":"Dollar"}],
  normalizedLocales: [{"code":"en","label":"English","file":"en.js","iso":"en","dir":"ltr"}],
  localeCodes: ["en"],
}

export const localeMessages = {
  'en.js': () => Promise.resolve(locale77427e78),
}
